(() => {
  const state = window.LmbProductReviewsPresentation || { instances: new Map() };
  if (window.LmbProductReviewsPresentation) {
    state.start(document);
    return;
  }
  window.LmbProductReviewsPresentation = state;
  const sources = {
    'Sort by': 'sort_by',
    'Customer Reviews': 'customer_reviews',
    'Write a review': 'write_review',
    'Cancel review': 'cancel_review',
    'Most Recent': 'most_recent',
    'Highest Rating': 'highest_rating',
    'Lowest Rating': 'lowest_rating',
    'Only Pictures': 'only_pictures',
    'Pictures First': 'pictures_first',
    'Videos First': 'videos_first',
    'Most Helpful': 'most_helpful',
    'Verified only': 'verified_only',
    'See all reviews': 'see_all',
    'Read more': 'read_more',
    'Show less': 'show_less',
    'Product Reviews': 'product_reviews',
    'Shop Reviews': 'shop_reviews',
    'Store Reviews': 'shop_reviews',
    'Be the first to write a review': 'no_reviews'
  };
  const controls = '.jdgm-rev-widg__title, .jdgm-write-rev-link, .jdgm-sort-dropdown option, .jdgm-sort-dropdown-label, .jdgm-sort-dropdown-label .visually-hidden, .jdgm-rev-widg__summary-text, .jdgm-rev__read-more, .jdgm-rev__read-less, .jdgm-rev-widg__subtab, .jdgm-histogram__clear-filter, .jdgm-rev-widg__empty-state';
  const connect = (section) => {
    if (state.instances.has(section)) return;
    let labels;
    try { labels = JSON.parse(section.querySelector('[data-lmb-reviews-ui]')?.textContent || '{}'); }
    catch (_) { return; }
    const locale = (section.dataset.lmbReviewsLocale || '').toLowerCase();
    if (!locale.startsWith('de') && !locale.startsWith('en')) return;
    const formatter = new Intl.DateTimeFormat(locale.startsWith('de') ? 'de-DE' : 'en-GB', {
      day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC'
    });
    const localize = (source) => {
      const trimmed = source.trim();
      const key = sources[trimmed];
      if (key && labels[key]) return source.replace(trimmed, labels[key]);
      const count = trimmed.match(/^Based on (\d+) (review|reviews)$/);
      if (count) {
        const template = labels[count[2] === 'review' ? 'based_on_one' : 'based_on'];
        if (template) return source.replace(trimmed, template.replace('__COUNT__', count[1]));
      }
      return source;
    };
    const apply = () => {
      section.querySelectorAll('.jdgm-sort-dropdown option').forEach((option) => {
        if (/picture|video|media/i.test(option.value)) option.remove();
      });
      section.querySelectorAll(controls).forEach((element) => {
        element.childNodes.forEach((node) => {
          if (node.nodeType !== 3) return;
          const translated = localize(node.nodeValue || '');
          if (translated !== node.nodeValue) node.nodeValue = translated;
        });
      });
      section.querySelectorAll('.jdgm-paginate__page[aria-label]').forEach((element) => {
        const original = element.getAttribute('aria-label');
        const page = original?.match(/^Page (\d+)$/);
        if (page && labels.page) {
          const translated = labels.page.replace('__COUNT__', page[1]);
          if (translated !== original) element.setAttribute('aria-label', translated);
        }
      });
      section.querySelectorAll('.jdgm-rev__timestamp[data-content]').forEach((element) => {
        const raw = element.getAttribute('data-content');
        const parts = raw?.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T]|$)/);
        if (!parts) return;
        const year = Number(parts[1]);
        const month = Number(parts[2]);
        const day = Number(parts[3]);
        if (year < 1900 || month < 1 || month > 12 || day < 1 || day > 31) return;
        const date = new Date(Date.UTC(year, month - 1, day));
        if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return;
        const formatted = formatter.format(date);
        if (element.textContent !== formatted) element.textContent = formatted;
      });
    };
    let frame = null;
    const observer = new MutationObserver(() => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => { frame = null; apply(); });
    });
    apply();
    observer.observe(section.querySelector('.lmb-pdp-reviews__widget'), {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['data-content', 'aria-label']
    });
    state.instances.set(section, () => {
      observer.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      state.instances.delete(section);
    });
  };
  state.start = (scope) => {
    if (scope.matches?.('.lmb-pdp-reviews')) connect(scope);
    scope.querySelectorAll('.lmb-pdp-reviews').forEach(connect);
  };
  document.addEventListener('shopify:section:load', (event) => state.start(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    state.instances.forEach((dispose, section) => {
      if (section === event.target || event.target.contains(section)) dispose();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => state.start(document), { once: true });
  else state.start(document);
})();

